// extracted by mini-css-extract-plugin
export default {"container":"UserEdit_container__3wXXn","modalContainer":"UserEdit_modalContainer__N0+VP"};